// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"customScroll_custom-scroll__K2PgP"};